import * as React from "react";
const SvgFiRrDeerRudolph = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-deer-rudolph_svg__a)">
      <path
        fill="#062147"
        d="M22.5 6.5c-.317 0-.611.099-.854.267-.587-.591-1.262-1.24-2.01-1.761A4 4 0 0 0 21 2a1 1 0 1 0-2 0c0 1.103-.897 2-2 2h-.5A2.503 2.503 0 0 1 14 1.5V1a1 1 0 1 0-2 0v.5c0 .924.28 1.784.76 2.5H11.5A2.503 2.503 0 0 1 9 1.5V1a1 1 0 1 0-2 0v.5C7 3.981 9.019 6 11.5 6h1.308C12.192 6.942 12 7.988 12 8.586V9.5a.5.5 0 0 1-.5.5H6.169A4.23 4.23 0 0 0 3.2 11.24c-.076.076-2.924 3.069-2.924 3.069a1 1 0 1 0 1.446 1.38l.35-.367c.119.936.363 1.646.618 2.385.1.293.207.599.31.938v2.354c0 1.654 1.346 3 3 3s3-1.346 3-3v-1h2v1c0 1.654 1.346 3 3 3s3-1.346 3-3v-2.115c.627-.746 2-2.695 2-5.485v-2.026l1.6-.22a2.175 2.175 0 0 0 1.842-1.655l.058.001a1.5 1.5 0 0 0 0-3zm-2.16 2.67-1.61.221A2.01 2.01 0 0 0 17 11.372v2.027c0 2.669-1.683 4.37-1.696 4.384A1 1 0 0 0 15 18.5V21a1.001 1.001 0 0 1-2 0v-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2a1.001 1.001 0 0 1-2 0v-2.5c0-.096-.295-1.084-.418-1.443-.324-.94-.58-1.683-.582-2.953 0-.537.218-1.052.616-1.45.415-.415.98-.653 1.553-.653h5.33c1.379 0 2.5-1.121 2.5-2.5v-.914c0-.265.082-2.586 2.868-2.586 1.183 0 2.546 1.351 3.567 2.385.034.13.066.391.066.615 0 .086-.064.158-.16.17z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-deer-rudolph_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDeerRudolph;
